module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_5-00122395fe1e8c59b19e3f2ca8759e04.jpg";